export const SET_NEW_PROJECT = 'SET_NEW_PROJECT';
export const SET_NEW_PROJECT_NAVIGATION = 'SET_NEW_PROJECT_NAVIGATION';
